<app-header></app-header>

<!-- Page title section -->
<div class="section-xl bg-image parallax" style="background-image: url('assets/images/backgrounds/title-bg-1.jpg')">
    <div class="bg-dark-05">
        <div class="container text-center z-index-1">
            <h1 class="fw-bold uppercase letter-spacing-1 m-0">About Us</h1>
        </div><!-- end container -->
    </div>
</div>
<!-- end Page title section -->

<!-- About section -->
<div class="section">
  <div class="container">
    <div class="row g-5 align-items-center">
      <div class="col-12 col-lg-6">
        <div class="row gallery-wrapper g-3">
          <div *ngFor="let item of aboutGalleryItems; let i = index" class="col-6 gallery-box img-class">
            <div class="gallery-img border-radius" (click)="openAboutGallery(i)" style="cursor: pointer;">
              <img [src]="item.src" [alt]="item.title" style="width: 100%; height: 100%; object-fit: cover;">
            </div>
          </div>
        </div><!-- end gallery-wrapper -->
      </div>
      <div class="col-12 col-lg-6">
        <div class="d-inline-block bg-light-turquoise px-3 py-2 border-radius-2 mb-3">
          <span class="font-small fw-medium uppercase line-height-100 text-gradient-1">Inspiring People</span>
        </div>
        <h3 class="fw-normal">We believe that great things in business are never done by one person. They're done by a team of people.</h3>
        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
      </div>
    </div><!-- end row -->
  </div><!-- end container -->
</div>
<!-- end About section -->

<!-- About Gallery Lightbox Modal -->
<div *ngIf="showAboutGalleryModal" class="gallery-modal" style="display: flex;" (click)="closeAboutGallery()">
  <div class="gallery-modal-content" (click)="$event.stopPropagation()">
    <div class="gallery-modal-header">
      <button (click)="closeAboutGallery()" class="gallery-modal-close">&times;</button>
    </div>
    <div class="gallery-modal-body">
      <img [src]="aboutGalleryItems[currentAboutGalleryIndex].src" [alt]="aboutGalleryItems[currentAboutGalleryIndex].title">
      <div class="gallery-modal-nav">
        <button (click)="previousAboutGalleryImage()" class="gallery-nav-btn gallery-nav-prev">
          <i class="bi bi-chevron-left"></i>
        </button>
        <span class="gallery-counter">{{ currentAboutGalleryIndex + 1 }} / {{ aboutGalleryItems.length }}</span>
        <button (click)="nextAboutGalleryImage()" class="gallery-nav-btn gallery-nav-next">
          <i class="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div><!-- end About Gallery Lightbox Modal -->

<!-- Parallax section -->
<div class="section-2xl bg-image parallax" style="background-image: url('assets/images/backgrounds/video-bg-3.jpg')">
    <div class="bg-dark-03">
        <div class="container text-center">
            <a class="button-circle button-circle-xl button-circle-white-2 button-circle-ripple icon-xl button-hover-shrink lightbox-media-link" (click)="openPopup()">
                <i class="bi bi-play"></i>
            </a>
        </div><!-- end container -->
    </div>
</div>
<!-- end Parallax section -->

<!-- Video Popup -->
<div class="video-popup" *ngIf="isOpen">
    <div class="popup-inner">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/CygqGDPoZWQ?si=0GVlvXAPieQYM4RY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button" class="close-btn">
            <i class='bi bi-x'></i>
        </button>
    </div>
</div>

<!-- Prices section -->
<div class="bg-gray-lighter bg-fade-white-top">
  <div class="section">
    <div class="container">
      <div class="mb-5">
        <div class="row text-center">
          <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3">
            <h2 class="display-6 font-family-outfit fw-normal animate-text">Pricing Table</h2>
            <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Integer tincidunt.</p>
          </div>
        </div>
      </div>
      <div class="row g-4 mt-5 text-center">
        <div *ngFor="let plan of pricingPlans" class="col-12 col-md-4 img-class">
          <div class="bg-white box-shadow hover-float border-radius p-4" [ngClass]="{ 'mt-lg-4': plan.id !== 2 }">
            <h6 class="font-small fw-medium uppercase letter-spacing-1">{{ plan.name }}</h6>
            <div class="mt-3">
              <h1 class="line-height-100 fw-medium mb-0 text-color-theme">{{ plan.price }}</h1>
              <span>monthly</span>
            </div>
            <ul class="list-unstyled mt-4">
              <li *ngFor="let feature of plan.features">{{ feature }}</li>
            </ul>
            <a class="button button-md button-gradient-1 button-rounded mt-4" routerLink="/pricing-table">Choose Plan</a>
          </div>
        </div>
      </div><!-- end row -->
    </div><!-- end container -->
  </div>
</div>
<!-- end Prices section -->

<!-- Sliding Text -->
<section class="section-sm pt-0">
    <div class="sliding-text pb-3">
        <div class="container-fluid pd-0 overflow-hidden">
            <div class="row">
            <div class="col-12">
                <h2 class="display-1 fw-semi-bold mb-0 opacity-1 text-gradient-1 font-family-philosopher font-italic text-capitalize animate-left">Top Selling HTML Template. Maximo Multipurpose Template.</h2>
            </div>
            </div>
        </div>
    </div>
</section>
<!-- end Sliding Text -->

<!-- Testimonial section -->
<div class="section pt-0">
    <div class="container">
        <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr testimonial-inner mrt-80">
          <ng-template carouselSlide *ngFor="let slide of slideStore">
            <!-- Testimonial box -->
            <div class="testimonial-box">
              <img class="mb-3" src="assets/images/testimonials/{{slide.image}}" alt="client-img">
              <h5 class="fw-normal line-height-140 m-0">{{slide.title}}</h5>
              <span class="font-small fw-normal">{{slide.subtitle}}</span>
              <p class="mt-3">{{slide.desc}}</p>
            </div>
          </ng-template>
        </owl-carousel-o>
    </div>
</div><!-- end container -->
<!-- end Testimonial section -->



